<template>
    <div>
        <b-btn v-bind:id="'exPop-prop-status'+id" title="Job Statuses" class="btn btn-light">Status Legends</b-btn>
        <b-popover v-bind:target="'exPop-prop-status'+id" triggers="focus">
            <table class="job-status-legends table ml-10">
                <tr>
                    <td class="jcolor Planned">&nbsp;</td>
                    <td class="jlabel">Planned</td>
                    <td class="jcolor">&nbsp;</td>
                    <td class="jcolor Started">&nbsp;</td>
                    <td class="jlabel">Started</td>
                </tr>
                <tr>
                    <td class="jcolor Completed">&nbsp;</td>
                    <td class="jlabel">Completed</td>
                    <td class="jcolor">&nbsp;</td>
                    <td class="jcolor Cancelled">&nbsp;</td>
                    <td class="jlabel">Cancelled</td>
                </tr>
                <tr>
                    <td class="jcolor Verified">&nbsp;</td>
                    <td class="jlabel">Verified</td>
                    <td class="jcolor">&nbsp;</td>
                    <td class="jcolor Endorsed">&nbsp;</td>
                    <td class="jlabel">Endorsed</td>
                </tr>
                <tr>
                    <td class="jcolor Expired">&nbsp;</td>
                    <td class="jlabel">Expired</td>
                    <td class="jcolor">&nbsp;</td>
                    <td class="jcolor Due">&nbsp;</td>
                    <td class="jlabel">Due</td>
                </tr>
            </table>
        </b-popover>   
    </div>     
</template>
<script>
export default {
    name: 'job-calendar-status',
    props: {
        id: {
            type: String,
            required: true
        },
    }
}
</script>
